module.exports = __webpack_public_path__ + "img/interational_shipping_img_2.45790d56.png";